import type { StatusStyleEntry } from "./bot-config-types";
import { Loader2, OctagonX, ShieldAlert, Square } from "lucide-react";

/**
 * Status styles shared between grid and delta-neutral configs.
 * Statuses with identical visual definitions in both configs are
 * extracted here so each config can spread from this object.
 */
export const SHARED_STATUS_STYLES = {
  PENDING: {
    icon: Loader2,
    label: "Pending",
    color: "text-amber-400",
    bg: "bg-amber-400/10",
    border: "border-amber-400/20",
    spin: true,
  },
  STOPPED: {
    icon: Square,
    label: "Stopped",
    color: "text-slate-400",
    bg: "bg-slate-400/10",
    border: "border-slate-400/20",
  },
  STOPPED_MAX_LOSS: {
    icon: ShieldAlert,
    label: "Max Loss",
    color: "text-amber-400",
    bg: "bg-amber-400/10",
    border: "border-amber-400/20",
  },
  ERROR: {
    icon: OctagonX,
    label: "Error",
    color: "text-red-400",
    bg: "bg-red-400/10",
    border: "border-red-400/20",
  },
} as const satisfies Record<string, StatusStyleEntry>;
